<form [formGroup]="dutyForm" (ngSubmit)="save()" style="max-width:400px;padding:24px;">
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="dutyAmount" placeholder="DUTY AMOUNT">
    <mat-hint>Flat fee added to customer price when duty is selected on an order</mat-hint>
  </mat-form-field>
  <button mat-raised-button type="submit" [disabled]="dutyForm.invalid || saving">SAVE</button>
</form>
